import { render, staticRenderFns } from "./SupportCategoryList.vue?vue&type=template&id=f419aa90&scoped=true&"
import script from "./SupportCategoryList.vue?vue&type=script&lang=js&"
export * from "./SupportCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./SupportCategoryList.vue?vue&type=style&index=0&id=f419aa90&lang=scss&scoped=true&"
import style1 from "./SupportCategoryList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f419aa90",
  null
  
)

export default component.exports